import * as React from 'react';
import { generateInnerHtml } from 'shared-react';
import './EConsentViewer.scss';

interface IEConsentViewerProps {
  htmlText: string;
}

class EConsentViewer extends React.Component<IEConsentViewerProps, {}> {
  render() {
    const { htmlText } = this.props;

    return (
      <div className="EConsentViewer">
        <div className="EConsentViewer-body">
          <div className="EConsentViewer-contentWrapper">
            <div
              className="EConsentViewer-econsentText BrandLinks"
              // We allow img here in addition to other tags because we embed images
              {...generateInnerHtml(htmlText, ['img'])}
            />
          </div>
        </div>
      </div>
    );
  }
}

export default EConsentViewer;
